import { Injectable, inject } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { LoanDataModel, ReferralInfoModel } from '../../cmg-1003/models';
import { SessionStore } from '../../core/state';
import { Subject } from 'rxjs';
import { iStoreActions } from '../core/store-actions.interface';

function createInitialState(): LoanDataModel {
  return <LoanDataModel>{
    antiSteering: {
      adjustableRateTransaction: { id: null, value: null },
      fixedRateTransaction: { id: null, value: null },
      option1InterestRate: { id: null, value: null },
      option1PointsAndFees: { id: null, value: null },
      option2InterestRate: { id: null, value: null },
      option2PointsAndFees: { id: null, value: null },
      option3InterestRate: { id: null, value: null },
      option3PointsAndFees: { id: null, value: null },
    },
    cemaLoan: {
      id: -1,
      value: 'False',
    },
  };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'cmg-1003-loan-store' })
export class Cmg1003LoanStore extends Store<LoanDataModel> implements iStoreActions<LoanDataModel> {
  private readonly _sessionStore = inject(SessionStore);

  salesPriceUpdate$ = new Subject<number>();
  private _initValue: LoanDataModel = null;
  constructor() {
    super(createInitialState());
  }

  override akitaPreUpdate(_: Readonly<LoanDataModel>, nextState: Readonly<LoanDataModel>): LoanDataModel {
    this._sessionStore.update({ lastUpdatedDateTime: Date.now() });
    return nextState;
  }

  salesPriceUpdate(value?: number): void {
    this.salesPriceUpdate$.next(value);
  }

  preInitialize(loanInformation: LoanDataModel): void {
    if (loanInformation && loanInformation.prepaymentPenaltyTerm === undefined) {
      loanInformation.prepaymentPenaltyTerm = null;
    }
    this.update(loanInformation);
    const referralForm = {
      referralType: null,
      referralPartner: null,
      referralCompany: '',
      referralContactName: '',
      relocationSourceType: null,
      referralContactNumber: '',
      referralEmailAddress: '',
      city: '',
      state: null,
      street: '',
      zipCode: '',
    };
    const info = { ...new ReferralInfoModel(), ...referralForm };
    this._initValue = { ...JSON.parse(JSON.stringify(this.getValue())), referralInfo: info };
  }

  get initialValue() {
    return this._initValue;
  }

  set initialValue(value: LoanDataModel) {
    this._initValue = value;
  }

  deleteAntiSteering() {
    this.update((loanData) => {
      return {
        ...loanData,
        antiSteering: {
          adjustableRateTransaction: { id: loanData.antiSteering.adjustableRateTransaction?.id, isDeleted: true },
          fixedRateTransaction: { id: loanData.antiSteering.fixedRateTransaction?.id, isDeleted: true },
          option1InterestRate: { id: loanData.antiSteering.option1InterestRate?.id, isDeleted: true },
          option1PointsAndFees: { id: loanData.antiSteering.option1PointsAndFees?.id, isDeleted: true },
          option2InterestRate: { id: loanData.antiSteering.option2InterestRate?.id, isDeleted: true },
          option2PointsAndFees: { id: loanData.antiSteering.option2PointsAndFees?.id, isDeleted: true },
          option3InterestRate: { id: loanData.antiSteering.option3InterestRate?.id, isDeleted: true },
          option3PointsAndFees: { id: loanData.antiSteering.option3PointsAndFees?.id, isDeleted: true },
        },
      };
    });
  }
}
